$('body').on('change', '#subcategory_id_seller_search', function () {
    let specialCategoryCardEl = $('#special_category_card');
    specialCategoryCardEl.addClass('d-none');

    let val = $(this).val();
    $(val).each(function (i, v) {
        if ($.inArray(parseInt(v), window.subcategoriesPickup) > -1) {
            $('#special_category_card').removeClass('d-none');
        }
    });
    //subcategoriesPickup
});
